module.exports = __webpack_public_path__ + "img/y_2021_2_hover.9bc99597.png";